import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import type { RootState } from "../../app/store";
import { AlegraItemsPageType } from "../../types/types";
import { API_URL } from "../../config";

export type GetAlegraItemsArgs = {
  start: number;
  limit: number;
};

export const alegraItemsApi = createApi({
  reducerPath: "alegraItems",
  baseQuery: fetchBaseQuery({
    baseUrl: API_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth.token;
      if (token) headers.set("Authorization", `Bearer ${token}`);
      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),
  tagTypes: ["AlegraItem"],
  endpoints: (builder) => ({
    getAlegraItems: builder.query<AlegraItemsPageType, GetAlegraItemsArgs>({
      query: ({ start, limit }) => ({
        url: "alegra-items",
        method: "GET",
        params: { start, limit },
      }),
      providesTags: ["AlegraItem"],
    }),
  }),
});

export const { useGetAlegraItemsQuery } = alegraItemsApi;

export default alegraItemsApi;
